var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckmarkRound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0C23.2839 0 30 6.7161 30 15C30 23.2839 23.2839 30 15 30C6.7161 30 0 23.2839 0 15C0 6.7161 6.7161 0 15 0ZM5.1177 13.623C5.90871 12.832 7.2048 12.832 7.99584 13.623L11.7131 17.3415C13.894 15.5743 18.2873 12.1209 23.3054 8.181C24.8418 6.96459 26.289 8.56068 24.9484 9.86967L13.1536 21.66C12.3532 22.4615 11.0841 22.444 10.2755 21.66L5.11908 16.5027C4.3269 15.7117 4.3269 14.4156 5.11908 13.6234L5.1177 13.623Z",
    fill: "#49B780"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkRound);
export default __webpack_public_path__ + "static/media/checkmark-round.58347bc01701ae12eeb6cac75247866d.svg";
export { ForwardRef as ReactComponent };